<div
    class="aspect-h-9 aspect-w-16 transform-gpu overflow-hidden rounded-lg bg-darkgrey">
    @if (cookieConsent | async) {
        <youtube-player
            appIntersectionObserver
            [intersectionDebounce]="100"
            [intersectionThreshold]="0.01"
            intersectionRootMargin="200px"
            (visibilityChange)="loadApi($event)"
            [videoId]="videoId"
            width="100%"
            height="100%">
        </youtube-player>
    } @else {
        <div class="p-2 text-white md:p-8">
            <div class="flex">
                <div class="w-full md:w-2/3">
                    <p class="pb-4">There would be a youtube video here.</p>
                    Sadly, the youtube player requires cookies to work.
                </div>
                <div class="hidden w-1/3 items-center justify-center md:flex">
                    <fa-icon
                        [icon]="faYoutube"
                        size="5x"
                        class="text-youtube"></fa-icon>
                </div>
            </div>
            <app-consent-accept-button
                text="Accept Cookies"
                class="pt-4"></app-consent-accept-button>
        </div>
    }
</div>
